import { render } from "./ImageEffect.vue?vue&type=template&id=70c5587f&scoped=true"
import script from "./ImageEffect.vue?vue&type=script&lang=js"
export * from "./ImageEffect.vue?vue&type=script&lang=js"

import "./ImageEffect.vue?vue&type=style&index=0&id=70c5587f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c5587f"]])

export default __exports__